(() => {
  const colors = {
    primaryBg: '#111111',
    primary: '#ffffff',
    hoverPrimary: '#7d6550',
    secondaryBg: '#faf8f6',
    secondary: '#161310',
    hoverSecondary: '#dad2c7',
    accentColor: '#b08d57',
    textColor: '#57514b',
  };

  const applyConfig = () => {
    window.KIRB_STORE_THEME = 'classic';
    window.KIRB_THEME_EXTENSION_CONFIG = Object.assign({}, window.KIRB_THEME_EXTENSION_CONFIG || {}, {
      centralApiUrl: 'https://ring-builder.apps.keyideasglobal.com',
      storeTheme: 'classic',
      themeStyleName: 'classic',
      theme_style_name: 'classic',
      colors,
    });

    const root = document.documentElement.style;
    root.setProperty('--kirb-classic-primary-bg', colors.primaryBg);
    root.setProperty('--kirb-classic-primary-text', colors.primary);
    root.setProperty('--kirb-classic-primary-hover', colors.hoverPrimary);
    root.setProperty('--kirb-classic-secondary-bg', colors.secondaryBg);
    root.setProperty('--kirb-classic-secondary-text', colors.secondary);
    root.setProperty('--kirb-classic-secondary-hover', colors.hoverSecondary);
    root.setProperty('--kirb-classic-accent-bg', colors.accentColor);
    root.setProperty('--kirb-classic-accent-text', colors.primary);
    root.setProperty('--kirb-classic-text-color', colors.textColor);
  };

  const sendThemeColors = () => {
    const iframe = document.getElementById('ringBuilderIframe');
    if (!iframe?.contentWindow) return;

    let targetOrigin = 'https://ring-builder.apps.keyideasglobal.com';
    try {
      targetOrigin = new URL(iframe.getAttribute('src') || iframe.src).origin;
    } catch (_error) {}

    iframe.contentWindow.postMessage(
      {
        __iframeBridge: true,
        version: 1,
        kind: 'event',
        event: 'user:theme_colors_updated',
        payload: {
          theme: 'classic',
          colors,
        },
      },
      targetOrigin,
    );
  };

  applyConfig();

  document.addEventListener('DOMContentLoaded', () => {
    applyConfig();
    sendThemeColors();

    let attempts = 0;
    const configTimer = window.setInterval(() => {
      attempts += 1;
      applyConfig();
      sendThemeColors();

      if (attempts >= 60) {
        window.clearInterval(configTimer);
      }
    }, 250);

    document.getElementById('ringBuilderIframe')?.addEventListener('load', () => {
      applyConfig();
      sendThemeColors();
      setTimeout(sendThemeColors, 500);
      setTimeout(sendThemeColors, 1500);
    });
  });
})();
